<template>
	<v-app-bar fixed app height="65" style="width: auto;">
        <!-- >>>  -->
        <v-btn fab small @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>
        <!-- <<<  -->


		<v-toolbar-title class="hidden-sm-and-down">Crews</v-toolbar-title>


		<v-spacer></v-spacer>


	</v-app-bar>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';


	export default {
		name: 'PeopleAppBar',


        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            }

        }, // eo props{}
        /* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: () => ({

			switchCabin: true,
			switchCockpit: true,
			// >>> ------------------------------
			filterTerm: ''

		}), // eo data()
		/* <<< ****************************************************************/




		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Resources_Filtered'
			])

		}, // eo computed{}
		/* <<< ****************************************************************/




		/* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_set_filterResources_filterTerm'
			]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
            * onKeyup_filterResources()
            *
            * Desc:
            * Note:
            *
            */
			onKeyup_filterResources: function() {

				const me = this;


				me.$toc('>>> views/people/components/core/AppBar.vue >>> onKeyup_filterResources');
				this.actn_set_filterResources_filterTerm(this.filterTerm);

			} // eo function onKeyup_filterResources()

		} // eo methods{}
		/* <<< ****************************************************************/
	};
</script>

<style scoped>
	.theme--light.v-app-bar.v-toolbar.v-sheet {
		background-color: #FFFFFF;
		border-color: #FFFFFF;
		color: rgba(0, 0, 0, 0.87);
	}

	.v-toolbar__title {
		font-weight: 300;
		color: #555555;
		font-size: 18px;
		margin-bottom: 0px;
	}

	.theme--light.v-btn.v-btn--has-bg {
		background-color: #fff;
	}

    .v-label {
        font-size: 14px !important; /* 16px */
    }
</style>
